
import { Vue, Component, Emit } from "vue-property-decorator";
import { OptionRecordsDto } from "@/api/service-proxies";
import WangEditor from "wangeditor";
@Component({
    name: "EditTextDialog",
    components: {},
})
export default class EditTextDialog extends Vue {
    dialogVisible = false;
    editor : WangEditor;
    editValue = ""; //所获取的编辑器内容 
    registrationType=0
    index=0
    type=0
    open(text1,registrationType,index,type) {
        console.log(registrationType,index,type)
       this.registrationType=registrationType
       this.index=index
       this.type=type
        this.dialogVisible = true;
        setTimeout(() => {
            this.editor = new WangEditor(document.getElementById("editor")); // 配置 onchange 回调函数，将数据同步到 vue 中
            this.editor.config.menus = [
                "head",
                "bold",
                "fontSize",
                "italic",
                "underline",
                "strikeThrough",
                "indent",
                "lineHeight",
                "foreColor",
                "backColor",
                "list",
                "justify",
                "quote",
                "emoticon",
                "splitLine",
                "undo",
                "redo",
            ];
            this.editor.config.colors = [
                "#f05b72",
                "#FA3F46",
                "#FF9915",
                "#4CCD78",
                "#0051FF",
                "#999999",
            ];
            //将传入的值赋给富文本
            this.editValue = text1;
            this.editor.config.onchange = (html) => {
                this.editValue = html;
            };
            this.editor.create();
            this.editor.txt.html(this.editValue);
        }, 500);

        
    }
    submit() {
        this.dialogVisible = false;
        this.onSuccess(this.editValue,this.registrationType,this.index,this.type);
        this.editor.destroy()//销毁富文本编辑器
    }
    @Emit("success")
    private onSuccess(str,registrationType,index,type) {
    }
}
